<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true">
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">到款查询</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef">
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs3>
                <v-text-field
                    label="对方单位"
                    :rules="rules.required"
                    v-model="form.dfdw"
                />
              </v-flex>
              <v-flex sm3>
                <v-menu
                    ref="refPzrqStart"
                    :close-on-content-click="false"
                    v-model="menuPzrqStart"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px">
                  <v-text-field
                      slot="activator"
                      v-model="form.pzrqStart"
                      label="凭证日期(起始)"
                      :rules="rules.endDate"
                      hint="格式YYYY-MM-DD"
                      persistent-hint
                  />
                  <v-date-picker
                      v-model="pzrqStart"
                      locale="zh-cn"
                      @change="nv => form.pzrqStart= nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex sm3>
                <v-menu
                    ref="refPzrqEnd"
                    :close-on-content-click="false"
                    v-model="menuPzrqEnd"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px">
                  <v-text-field
                      slot="activator"
                      v-model="form.pzrqEnd"
                      label="凭证日期(截止)"
                      :rules="rules.endDate"
                      hint="格式YYYY-MM-DD"
                      persistent-hint
                  />
                  <v-date-picker
                      v-model="pzrqEnd"
                      locale="zh-cn"
                      @change="nv => form.pzrqEnd= nv"
                  />
                </v-menu>
              </v-flex>
              <v-flex sm3 class="text-xs-right">
                <v-btn color="primary" @click.native="onSearch">检索</v-btn>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            item-key="dbid"
            select-all
            class="elevation-0"
            :pagination.sync="query"
            :rows-per-page-items="[5, 10, 25]"
            :loading="isLoading"
            no-data-text="没有数据。">
          <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
              ></v-checkbox>
            </td>
            <td class="">{{ props.item.zy }}</td>
            <td class="">{{ props.item.dfdw }}</td>
            <td class="">{{ props.item.pzrq }}</td>
            <td class="text-xs-right">{{ props.item.je | currency }}</td>
            <td class="">{{ props.item.pznm }}/{{ props.item.flbh }}</td>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import mixin from '@/mixin'

const baseURI = '/api/cw/lkxx';
const projCwLkxxURI = '/api/proj/cw_lkxx';

export default {
  mixins: [mixin.edit(baseURI)],
  props: ['value'],
  components: {},

  data() {
    return {
      selected: [],
      isLoading: false,
      formValid: false,
      query: {
        statusIsNull: "true",
        page: 1,
        rowsPerPage: 10,
        sortBy: 'pzrq',
        descending: true,
        totalItems: null
      },

      form: {
        dfdw: "",
        pzrqStart: "",
        pzrqEnd: ""
      },

      items: [],
      freshItem: {
        "dfdw": null,
      },

      headers: [
        // {text: '#', sortable: false, value: 'rank', width: 18},
        {text: '摘要', sortable: false, value: 'zy', align: 'left'},
        {text: '对方单位', sortable: false, value: 'dfdw', align: 'left'},
        {text: '凭证日期', sortable: false, value: 'pzrq', width: 150, align: 'left'},
        {text: '金额', sortable: false, value: 'je', align: 'right'},
        {text: '凭证号/分录号', sortable: false, value: 'pzrq', width: 150},
      ],

      pzrqStart: '',
      menuPzrqStart: false,

      pzrqEnd: '',
      menuPzrqEnd: false,

      /**
       * 验证规则
       */
      rules: {}
    }
  },

  watch: {},

  created() {
    this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
        .then(
            rsp => {
              this.isLoading = false;
              this.items = rsp.data.items.map(
                  it => {
                    it.dbid = `${it.pznm}/${it.flbh}`;
                    return it;
                  }
              );
            })
        .finally(() => this.isLoading = false);
  },

  methods: {
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.isLoading = true;
      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.isLoading = false;
                this.items = rsp.data.items.map(
                    it => {
                      it.dbid = `${it.pznm}/${it.flbh}`;
                      return it;
                    }
                );
              })
          .finally(() => this.isLoading = false);
    },
    onSave() {
      let vm = this;
      window.console.log("in test")
      let pznmAndFlbh = this.selected.map(
          it => {
            return {"pznm": it.pznm, 'flbh': it.flbh}
          }
      );
      this.axios.post(projCwLkxxURI, pznmAndFlbh)
          .then(rsp => {
            vm.visible = false;
            //vm.$emit('input', false);
            vm.$emit('ok', rsp.data);
            vm.loading = false;
          })
          .finally(ex => {
                vm.loading = false;
                if (ex) {
                  window.console.error(ex);
                }
              }
          )
    }
  }
}
</script>
